import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsClockifyComponent } from './simple-icons-clockify.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsClockifyComponent ],
    exports:      [ SimpleIconsClockifyComponent ],
    bootstrap:    []
})
export class SimpleIconsClockifyModule {}
